import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  setStorage(key, value) {
    localStorage.setItem(key, value)
  }
  getStorage(key) {
    return localStorage.getItem(key)
  }
  removeStorage(key) {
    return localStorage.removeItem(key)
  }
}
